// extracted by mini-css-extract-plugin
module.exports = {"productName":"_11_WM","bottomGutter":"nnSM2"};